import { Button } from '@components/Button/Button';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { useRouter } from 'expo-router';
import { H1, Text, YStack } from 'tamagui';

/**
 * Not Found screen for Expo Router.
 * Displays a message when a route is not found.
 */
export default function NotFoundScreen(): React.ReactNode {
  const router = useRouter();
  const { t } = useAppTranslation();

  return (
    <YStack f={1} jc="center" ai="center" padding="$6" gap="$6">
      <YStack>
        <H1 variant="header1" color="$color" ta="center">
          {t('notFound.title')}
        </H1>
        <Text ta="center">{t('notFound.description')}</Text>
      </YStack>
      <Button title={t('buttons.back')} onPress={() => router.replace('/')} />
    </YStack>
  );
}
